export default __webpack_public_path__ + "static/media/ArrowLeftSwitch.aff9b786.svg";